const EKycVerifiedIcon = ({
  height = "24px",
  width = "24px",
}: {
  height?: string;
  width?: string;
}) => { 
  return (
    <svg
      style={{ width: `${width}`, height: `${height}` }} // Use inline styles here
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.4727 8.90527C19.7383 7.3916 19.8213 5.67871 19.0713 4.92871C18.3223 4.17771 16.6094 4.25977 15.0947 4.52734C14.2129 3.26855 13.0596 2 12 2C10.9404 2 9.78711 3.26855 8.90527 4.52734C7.3916 4.25977 5.67773 4.17773 4.92871 4.92871C4.17871 5.67871 4.26171 7.3916 4.52734 8.90527C3.26855 9.78711 2 10.9404 2 12C2 13.0596 3.26855 14.2129 4.52734 15.0947C4.26172 16.6084 4.17871 18.3213 4.92871 19.0713C5.67676 19.8213 7.39063 19.7402 8.90527 19.4727C9.78711 20.7315 10.9404 22 12 22C13.0596 22 14.2129 20.7315 15.0947 19.4727C16.6084 19.7393 18.3223 19.8223 19.0713 19.0713C19.8213 18.3213 19.7383 16.6084 19.4727 15.0947C20.7315 14.2129 22 13.0596 22 12C22 10.9404 20.7315 9.78711 19.4727 8.90527Z"
        fill="#449F52"
      />
      <path
        d="M11.5001 15.0013C11.3687 15.0015 11.2387 14.9757 11.1173 14.9254C10.996 14.8751 10.8858 14.8013 10.7931 14.7083L8.79308 12.7083C8.60837 12.5202 8.50541 12.2668 8.5066 12.0032C8.5078 11.7396 8.61305 11.4871 8.79945 11.3007C8.98586 11.1143 9.23834 11.009 9.50195 11.0078C9.76557 11.0067 10.019 11.1096 10.2071 11.2943L11.5001 12.5873L14.7931 9.29429C14.9812 9.10958 15.2346 9.00662 15.4982 9.00782C15.7618 9.00901 16.0143 9.11426 16.2007 9.30067C16.3871 9.48707 16.4924 9.73955 16.4936 10.0032C16.4947 10.2668 16.3918 10.5202 16.2071 10.7083L12.2071 14.7083C12.1143 14.8013 12.0041 14.8751 11.8828 14.9254C11.7615 14.9757 11.6314 15.0015 11.5001 15.0013Z"
        fill="white"
      />
    </svg>
  );
};
export default EKycVerifiedIcon;
